/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import * as React from 'react';
import './assignRoles.scss'
import Button from '@mui/material/Button';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { FetchTeams, GetSelectedUserDetails, GetUserRoles } from '../../constants/api-urlConstants';
import { useEffect } from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import instance from '../../utils/axiosInstance';
import { Box, Checkbox, CircularProgress, Divider, FormControl, FormControlLabel, FormLabel, IconButton, InputLabel, ListSubheader, MenuItem, OutlinedInput, Radio, RadioGroup, Select, SelectChangeEvent, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SnackBarMessage } from '../snackBar/snackBar';
import { TimerValusSet } from '../../context/TimerContext';
import { ROLES } from '../../constants/commonConstants';
import { Role, User } from './model';
import { isBasicOrProUser, isPayGUserRoleSelected } from '../../utils';
import { Add } from '@mui/icons-material';
import { Modal } from '../Modal';
import CreateTeam from '../team';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 270,
    },
  },
};

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

export const AssignRoles: React.FC<any> = ({ openPopup, hidePopup, selectedUserID, showMsgOnAssign, confirmationFlag }) => {

  const { setUserHeartBeat, timeExit } = React.useContext(TimerValusSet);
  const [statusIsLoading, setStatusIsLoading] = React.useState(false);
  const [showPopup, setshowPopup] = React.useState(openPopup);
  const [rolesList, setRoles] = React.useState<Role[]>([]);
  const [expiryDate, setExpiryDate] = React.useState<any>();
  const [selectedRoleIds, setSelectedRoleIds] = React.useState<any>([]);
  const [errors, setErrors] = React.useState({ role: false, mfa2fa: false , team: false});
  const [mfa2FaStatus, setMfa2FaStatus] = React.useState<{ isTwofaEnabled: boolean, isMfaEnabled: boolean }>({ isMfaEnabled: false, isTwofaEnabled: false });
  const [openCreateNewTeam, setOpenCreateNewTeam] = React.useState(false);
  const [teams, setTeams] = React.useState([]);
  const [myTeam, setMyTeam] = React.useState<any>({});
  const [msgConfig, setMsgConfig] = React.useState({
    type: '',
    message: '',
    snackFlag: false
  });
  const [user, setUser] = React.useState<User>();
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    getUserDetails(selectedUserID);
    fetchTeamsList();
  }, []);

  const getNonTrialRoleNames = (roleIds: number[]) => {
    const selectedRoles = rolesList.filter(role => roleIds.includes(role.id));
    const selectedNonTrialRoles = selectedRoles.map(r => r.name.key).filter(r => ![ROLES.CONTRACTS_TRAIL, ROLES.GUEST, ROLES.SSO_USER].includes(r));
    return selectedNonTrialRoles;
  }

  const getUserDetails = (id: any) => {
    const USER_API_BASE_URL = `${GetSelectedUserDetails}${id}`;
    instance
      .get(USER_API_BASE_URL)
      .then((response) => {
        setStatusIsLoading(false);
        setUserHeartBeat(timeExit());
        if (response.data.success) {
          const res = response.data.data;
          const selectedIDs: any = [];
          res.roles.forEach((item: any) => {
            selectedIDs.push(item.id)
          });
          setMyTeam(res.team);
          setUser(res);
          setExpiryDate(res?.expiryDate ? dayjs(res?.expiryDate) : null);
          getRoles(selectedIDs);
          setSelectedRoleIds(selectedIDs);
          setMfa2FaStatus({ isTwofaEnabled: res.twofaEnabled, isMfaEnabled: res.mfaEnabled });
        }
      })
      .catch((error) => {
        setStatusIsLoading(false);
      });
  }

  const disbaleRole = (value: any, data: any) => {
    value.forEach((id: any) => {
      data.forEach((item: any) => {
        switch (id) {
          case 1:
            setSelectedRoleIds([1]);
            item.id === 1 ? item.isDisabled = false : item.isDisabled = true;
            break;
          case 5:
            setSelectedRoleIds([5]);
            item.id === 5 ? item.isDisabled = false : item.isDisabled = true;
            break;
          case 7:
            setSelectedRoleIds([7]);
            item.id === 7 ? item.isDisabled = false : item.isDisabled = true;
            break;
        }
      });
    });
  };

  const handleChange = (value: number[]) => {    
    if (value[0] !== selectedRoleIds[0]) {            
      setExpiryDate(null);
      setMyTeam({});
      setMfa2FaStatus({ isTwofaEnabled: false, isMfaEnabled: false });
    }
    setSelectedRoleIds(value);
    const showMfaTwofa = Boolean(getNonTrialRoleNames(value)?.length);
    if (!showMfaTwofa) {
      setMfa2FaStatus({ isTwofaEnabled: false, isMfaEnabled: false });
    }
    rolesList.forEach((item: any) => {
      item.isDisabled = false;
    });
    setErrors(old => ({ ...old, role: false , team: false, mfa2fa: false}));
    disbaleRole(value, rolesList);
  };  

  const getRoles = (ids: any) => {
    const USER_API_BASE_URL = `${GetUserRoles}`;
    instance
      .get(USER_API_BASE_URL)
      .then((response) => {
        const res = response.data;
        setUserHeartBeat(timeExit());
        if (res.success) {
          res.data.forEach((item: any, index: any) => {
            item.isDisabled = false;
          });
          setRoles(res.data);
          disbaleRole(ids, res.data);
        }
      })
      .catch(() => { });
  }

  const BootstrapDialogTitle = (props: DialogTitleProps) => {
    const { children, onClose, ...other } = props;

    return (
      <div>
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
          {children}
          {onClose ? (
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
      </div>
    );
  };

  const showMfaTwofa = Boolean(getNonTrialRoleNames(selectedRoleIds)?.length) && user?.status !== 'VALIDATION_PENDING';

  const saveChangesClick = () => {
    if (selectedRoleIds.length === 0) {      
      setErrors(old => ({ ...old, role: true }));
      return;
    } else if (showMfaTwofa && !mfa2FaStatus.isMfaEnabled && !mfa2FaStatus.isTwofaEnabled && !myTeam?.id) {
      setErrors(old => ({ ...old, mfa2fa: true, team: true}));
      return;
    } else if (showMfaTwofa && !mfa2FaStatus.isMfaEnabled && !mfa2FaStatus.isTwofaEnabled) {
      setErrors(old => ({ ...old, mfa2fa: true }));
      return;
    } else if (showMfaTwofa && !myTeam?.id && (isPayGUserRoleSelected(selectedRoleNames) || isBasicOrProUser(selectedRoleNames))) {
      setErrors(old => ({...old, team: true}));
      return;
    } else {      
      const validateExpiryDate = getSelectedRoleNames().includes(ROLES.CONTRACTS_SUBSCRIBER) ? expiryDate : "";
      setErrors(old => ({ mfa2fa: false, role: false , team: false}));
      confirmationFlag(true, selectedRoleIds, mfa2FaStatus, myTeam, validateExpiryDate);
      setSelectedRoleIds([]);
    }
  };

  const closeRoles = () => {
    setshowPopup(false);
    hidePopup(false);
    setSelectedRoleIds([]);
  };

  const handleCloseCreateNewTeam = () => {
    setOpenCreateNewTeam(false);
  }

  const fetchTeamsList = () => {
    const TEAMS_API_BASE_URL = `${FetchTeams}`;
    instance.get(TEAMS_API_BASE_URL).then((res) => {
      const teams = res.data.data;
      setTeams(teams);
    });    
  }

  const fetchAndClose = () => {
    fetchTeamsList();
    handleCloseCreateNewTeam();
  }

  const selectedRoleNames: string[] = [];
  selectedRoleIds.forEach((ele: any) => {
    rolesList.forEach((role: any) => {
      if (ele === role.id) {
        selectedRoleNames.push(role.name.key)
      }
    })
  });

  const handleChangeTeam = (event: any) => {
    const selectedTeam = teams.find((team: { id: number }) => team.id === event.target.value);
    setErrors(old => ({...old, team: selectedTeam? false: true}));
    setMyTeam(selectedTeam);
  }

  const getSelectedRoleNames = () => {
    return rolesList.filter(role => selectedRoleIds?.includes(role.id)).map(d => d?.name?.key);
  }

  return (
    <>
      <div>
        <BootstrapDialog
          aria-labelledby="customized-dialog-title"
          open={showPopup}
        >
          <div className="rolesPopupWrapper">
            <BootstrapDialogTitle
              id="customized-dialog-title"
              onClose={closeRoles}
            >
              <span className='titleText'> Assign Roles</span>
            </BootstrapDialogTitle>
            <Divider />
            <div className='rolesWrapper'>
              <Box sx={{ p: '8px' }}>
                <FormControl fullWidth error={errors.role}>
                  <InputLabel id="demo-multiple-checkbox-label">Select Roles *</InputLabel>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    value={rolesList.length > 0 ? selectedRoleIds : ''}
                    onChange={(event) => {
                      handleChange([event.target.value]);
                    }}
                    input={<OutlinedInput label="Select Roles *" />}
                    renderValue={value => {
                      let roleIds: any = []
                      value.forEach((ele: any) => {
                        rolesList.forEach((role: any) => {
                          if (ele === role.id) {
                            roleIds.push(role.name.value)
                          }
                        })
                      });
                      return roleIds.join(', ')
                    }}
                    MenuProps={MenuProps}
                  >
                    {rolesList.length && rolesList.map((role: any) => (
                      <MenuItem key={role.id} value={role.id} disabled={role.isDisabled}>
                        <ListItemText primary={role.name.value}/>
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.role && (
                    <FormHelperText error={errors.role}>
                      Please select at least 1 role
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>
              {getSelectedRoleNames().includes(ROLES.CONTRACTS_SUBSCRIBER) &&
                <Box sx={{ p: '8px' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Expiry Date"
                      value={expiryDate}
                      onChange={(value) => setExpiryDate(value)}
                      minDate={dayjs()}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          name: 'expirationDate',
                          id: 'expirationDate',
                        },
                        field: {
                          onClick: () => setOpen(true),
                        }

                      }}
                      open={open}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                    />
                  </LocalizationProvider>
                </Box>
              }
              {teams.length > 0 && (isPayGUserRoleSelected(selectedRoleNames) || isBasicOrProUser(selectedRoleNames)) &&
                <Box sx={{ p: '8px' }}>
                  <FormControl fullWidth error={errors.team}>
                    <InputLabel id="select-team-checkbox-label">Select Team *</InputLabel>
                    <Select
                      labelId="team-multiple-checkbox-label"
                      id="team-checkbox"
                      className="team"
                      value={myTeam?.id ? myTeam?.id: ''}
                      onChange={handleChangeTeam}
                      input={<OutlinedInput label="Select Team *" />}
                      renderValue={value => {
                        const team: any = teams.find((ele: any) => {
                          return ele.id === value
                        });
                        return team.name;
                      }}
                    >
                      <ListSubheader>
                        <Box
                          sx={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}
                          onClick={() => setOpenCreateNewTeam(true)}
                        >
                          <Add /> Create New
                        </Box>
                      </ListSubheader>
                      {teams.length && teams.map((team: {id: string, name: string}) => (
                        <MenuItem key={team.id} value={team.id}>
                          <ListItemText primary={team.name} />
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.team && (
                    <FormHelperText error={errors.team}>
                      Please create or select team for user
                    </FormHelperText>
                  )}
                  </FormControl>
                </Box>
              }
              {showMfaTwofa &&
                <FormControl fullWidth error={errors.mfa2fa}>
                  <Box className="descWrapper" sx={{ marginTop: 2, px: '8px' }}>
                    <FormLabel id="radios-label">
                      <div className="titleDescConfirm">Authentication Mechanism *</div>
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="radio-buttons-mfa-2fa"
                      name="radio-buttons-mfa-2fa"
                      value={mfa2FaStatus.isMfaEnabled ? 'MFA' : mfa2FaStatus.isTwofaEnabled ? '2FA' : ''}
                      onChange={(e: any) => {
                        const value = (e.target.value);
                        const is2fa = value === '2FA';
                        const isMfa = value === 'MFA';
                        setMfa2FaStatus({
                          isMfaEnabled: isMfa,
                          isTwofaEnabled: is2fa
                        });
                        setErrors(old => ({ ...old, mfa2fa: false }));
                      }}
                    >
                      <FormControlLabel value="MFA" control={<Radio />} label="MFA" />
                      <FormControlLabel value="2FA" control={<Radio />} label="2FA" />
                    </RadioGroup>
                  </Box>
                </FormControl>
              }
            </div>
            <div className="popupActions">
              <div className="popupActionsWrapper">
                <Button className='secondaryBtn' onClick={closeRoles} style={{ textTransform: "none" }} >
                  Cancel
                </Button>
                {statusIsLoading && <div className="loader">
                  <div>
                    <CircularProgress size={25} />
                  </div>
                </div>
                }
                {!statusIsLoading && <Button autoFocus className="primeryBtn" onClick={saveChangesClick} style={{ textTransform: "none", }}>
                  Save
                </Button>}
              </div>
            </div>
          </div>
        </BootstrapDialog>
      </div>
      {
        msgConfig.snackFlag &&
        <div>
          <SnackBarMessage snacBarValue={msgConfig} />
        </div>
      }
      <Modal title={"Create New Team"} open={openCreateNewTeam} onClose={handleCloseCreateNewTeam}>
        <CreateTeam onCancel={handleCloseCreateNewTeam} fetchAndClose={fetchAndClose} />
      </Modal>
    </>
  );
}